import { Targets } from '@atlassiansox/cross-flow-base-types';
import type {
	ImplicitMessageCreator,
	ImplicitMessageResponse,
} from '@post-office/shared-contracts/implicit-message';
import type { RequestContext } from '@post-office/shared-contracts/shared-request-middleware-context/requestContext';

import { type MessageTemplateContext } from '..';

export const IT_SERVICE_MANAGEMENT = 'jsm.it-service-management';
export const SIMPLIFIED_IT_SERVICE_MANAGEMENT_BASIC =
	'com.atlassian.servicedesk:simplified-it-service-management-basic';
export const SIMPLIFIED_IT_SERVICE_MANAGEMENT_ADVANCED =
	'com.atlassian.servicedesk:simplified-it-service-management';
export const COMPANY_MANAGED_GENERAL_SERVICE_PROJECT =
	'com.atlassian.servicedesk:company-managed-general-service-project';
export const JIRA_POLARIS_ROADMAP = 'jira.polaris:roadmap';
export const JIRA_POLARIS_PRIORITIZATION = 'jira.polaris:prioritization';
export const JIRA_POLARIS_DISCOVERY = 'jira.polaris:discovery';

const rerankCandidateList: Array<MessageTemplateContext> = [
	{
		entityId: JIRA_POLARIS_DISCOVERY,
		productKey: Targets.JIRA_PRODUCT_DISCOVERY,
		recommendationSessionId: 'placeholder',
	},
	{
		entityId: JIRA_POLARIS_ROADMAP,
		productKey: Targets.JIRA_PRODUCT_DISCOVERY,
		recommendationSessionId: 'placeholder',
	},
	{
		entityId: JIRA_POLARIS_PRIORITIZATION,
		productKey: Targets.JIRA_PRODUCT_DISCOVERY,
		recommendationSessionId: 'placeholder',
	},
	{
		entityId: COMPANY_MANAGED_GENERAL_SERVICE_PROJECT,
		productKey: Targets.JIRA_SERVICE_DESK,
		recommendationSessionId: 'placeholder',
	},
	{
		entityId: IT_SERVICE_MANAGEMENT,
		productKey: Targets.JIRA_SERVICE_DESK,
		recommendationSessionId: 'placeholder',
	},
];

export const implicitMessageCreator: ImplicitMessageCreator<MessageTemplateContext> = async (
	requestContext: RequestContext,
): Promise<ImplicitMessageResponse<MessageTemplateContext>[]> => {
	const { logger, orchestrationContext } = requestContext;

	const tenantId = orchestrationContext.tenantId;
	const userId = orchestrationContext.recipient.userId;

	if (!tenantId) {
		logger.error('JSMGROWTH-204 experiment tenantId is not available');
		return [];
	}

	if (!userId) {
		logger.error('JSMGROWTH-204 experiment userId is not available');
		return [];
	}

	return rerankCandidateList
		.filter((candidate) => candidate.entityId !== JIRA_POLARIS_DISCOVERY)
		.map((recommendation) => ({
			messageTemplateContext: recommendation,
			messageInstanceSeed: {
				value: `nav-4-projects-section-recommendation.${recommendation.entityId}`,
				version: '1',
			},
		}));
};
